import { UtilityService } from '../../../infrastructure/services/utils';
import { AnalyticsModel } from './AnalyticsModel';
import { AnalyticsActions } from './IAnalyticsTasks';
import { AnalyticsConstants } from './constants';
import { IRefinerClick } from './IRefinerClick';
import { store } from '../../store';
import refinersData from '../../configurations/refiner.json';
import { appConstants } from '../../configurations/constants';

/**
 * create model for analytics api recent search and clicked items
 * @param   {object} data api payload data
 */
export class RefinerClickModel extends AnalyticsModel {
  constructor(data: IRefinerClick) {
    const paxContextGuid = UtilityService.generateGuid();
    super(data, paxContextGuid);
    const { latency } = store.getState().search;
    const { browseConfigJSON } = store.getState().browseSearch;
    let JsonData: any;
    let refinerName: string = '';
    let valuesForKey: any;
    let valueForKey: any;
    let RefinerValues: any;
    let emptyArr = [AnalyticsConstants.NoRefinersApplied];
    //obtaining refiner values with refiner values
    if (data.FlagForContentAge) {
      const refinerValuesArray = data.RefinerValues;

      if (Object.keys(refinerValuesArray).length > 0) {
        RefinerValues = refinerValuesArray[0]
          ? Object.values(refinerValuesArray[0])[0]
          : Object.values(refinerValuesArray)[0];
      }

      if (RefinerValues?.length === 0) RefinerValues = emptyArr;
    } else {
      RefinerValues = data.RefinerValues;
    }

    //obtaining refiner name with Refiner keys
    if (data.FlagForContentAge && data.RefinerValues) {
      const refinerKeyArray = data.RefinerValues;

      if (Object.keys(refinerKeyArray).length > 0) {
        refinerName = refinerKeyArray[0]
          ? Object.keys(refinerKeyArray[0])[0]
          : Object.keys(refinerKeyArray)[0];
      } else {
        refinerName = AnalyticsConstants.date;
      }
    }

    // deciding on which json to use
    if (data.PageURL?.toLowerCase().includes('browse')) {
      JsonData = browseConfigJSON;
      valueForKey = refinerName;
    } else {
      JsonData = refinersData;
      valuesForKey = JsonData.filter((item: any) => item[refinerName]);
      if (Object.keys(valuesForKey).length > 0) {
        valueForKey = data.FlagForContentAge
          ? valuesForKey[0][refinerName]
          : AnalyticsConstants.date;
      } else {
        valueForKey = AnalyticsConstants.date; // Handle the case where valuesForKey is empty
      }
    }
    let searchParams = new URLSearchParams(window.location.href).get('c')?.toLowerCase();
    const isSemantic = data.Query && data?.Query.trim().split(/\s+/).length >= 4 ? "semanticsearch" : "keywordsearch"
    const site = window.location.origin
      ? `${window.location.origin}#${isSemantic}`
      : null;
    if (this.analyticsData.eventData) {
      this.analyticsData.refiner = [
        {
          ...this.analyticsData.eventData,
          Query: data.Query ? data.Query : null,
          Issues:
            data.Results === 0
              ? [AnalyticsConstants.ZeroResults]
              : [AnalyticsConstants.NoIssues],
          SearchURL: data.FlagForContentAge && searchParams != appConstants.intranet
            ? window.location.origin + '/#' + data.PageURL
            : window.location.href,
          Action: AnalyticsActions.refiner,
          PageURL: (window.location.origin + '/#' + data.PageURL)?window.location.origin + '/#' + data.PageURL : null,
          RefinerName: data.FlagForContentAge
            ? refinerName
            : AnalyticsConstants.date,
          RefinerValues: RefinerValues,
          Latency: latency ? latency : 0,
          Results: data.Results ? data.Results : 0,
          ActionValue: data.FlagForContentAge
            ? valueForKey
            : AnalyticsConstants.contentAge,
            Site: site
        }
      ];
      delete this.analyticsData.eventData;
    }
  }
}
